import './Instagram.scss';
import { ChannelsNames } from '../Channels';
import { ChannelBaseController } from '../ChannelBaseController';
import { ChannelsFeatures } from '../ChannelsFeatures';
import { StatusFacebookPopupConnectionEnum } from '../facebook/resources/PopupConnection';
import { CHANNEL_CONFIGURATION_INSTAGRAM_PRIVATE_REPLY_FOR_LIVES_TOGGLE_CLICKED, CHANNEL_CONFIGURATION_INSTAGRAM_PRIVATE_REPLY_TOGGLE_CLICKED, CHANNEL_CONFIGURATION_INSTAGRAM_STORY_MENTION_TOGGLE_CLICKED, CHANNEL_CONFIGURATION_INSTAGRAM_STORY_REPLY_TOGGLE_CLICKED, CHANNEL_CONNECTION_INSTAGRAM_CONFIGURATIONS_CLICKED, CHANNEL_CONNECTION_INSTAGRAM_OVERVIEW_CLICKED, CHANNEL_CONNECTION_INSTAGRAM_CURRENT_ACTIVATION_STEP, CHANNEL_CONNECTION_INSTAGRAM_FACEBOOK_LOGIN_EMBEDDED, CHANNEL_DISCONNECTION_INSTAGRAM_START, CHANNEL_DISCONNECTION_INSTAGRAM, CHANNEL_CONNECTION_INSTAGRAM_ERROR_PAGES, CHANNEL_CONNECTION_INSTAGRAM_CLICK_CONNECT, CHANNEL_CONNECTION_INSTAGRAM_CONNECTION_SUCCESSFUL, CHANNEL_CONNECTION_INSTAGRAM_CONNECTION_ERROR, CHANNEL_CONNECTION_INSTAGRAM_LOAD_ACCOUNT_ERROR, CHANNEL_CONFIGURATION_INSTAGRAM_ICE_BREAKER, CHANNEL_CONFIGURATION_INSTAGRAM_PRIVATE_REPLY_FOR_LIVES_KEYWORDS_SAVED, CHANNEL_CONFIGURATION_INSTAGRAM_PRIVATE_REPLY_KEYWORDS_SAVED, } from '../ChannelsSegmentEvents';
import { InstagramStepsEnum } from './InstagramStepsEnum';
import { InstagramErrorEnum } from './InstagramErrorEnum';
import { InstagramPermissionErroEnum } from './InstagramPermissionErroEnum';
import { InstagramImagesStepsEnum } from './InstagramImagesStepsEnum';
// Controllers
import { InstagramSuccesConnectModalControllerDpr } from './modals/InstagramSuccesConnectModalControllerDpr';
import { InstagramDisconnectModalController } from './modals/InstagramDisconnectModalController';
import { InstagramSuccesConnectModalController } from './modals/InstagramSuccesConnectModalController';
// Modals
import InstagramSuccesConnectModalDpr from './modals/InstagramSuccesConnectModalViewDpr.html';
import InstagramSuccesConnectModal from './modals/InstagramSuccesConnectModalView.html';
import InstagramDisconnectModal from './modals/InstagramDisconnectModalView.html';
// Views
import '!ng-cache-loader!./instagramSteps/InstagramOverviewDisconnectedView.html';
import '!ng-cache-loader!./instagramSteps/InstagramOverviewConnectedView.html';
import '!ng-cache-loader!./instagramSteps/InstagramSteps.html';
import '!ng-cache-loader!./instagramSteps/ProfessionalInstagramStep.html';
import '!ng-cache-loader!./instagramSteps/CommercialFacebookStep.html';
import '!ng-cache-loader!./instagramSteps/LinkedAccountsStep.html';
import '!ng-cache-loader!./instagramSteps/MessagesAccessStep.html';
import '!ng-cache-loader!./instagramSteps/BlipConnectionStep.html';
import '!ng-cache-loader!./instagramSteps/InstagramConfigurationConnectedView.html';
import '!ng-cache-loader!./instagramSteps/InstagramConfigurationDisconnectedView.html';
import '!ng-cache-loader!./instagramSteps/InstagramNotLinkedErrorStep.html';
import '!ng-cache-loader!./instagramSteps/InstagramConnectPageView.html';
import '!ng-cache-loader!./instagramSteps/InstagramConnectPageErrorView.html';
import '!ng-cache-loader!./instagramSteps/ConnectedBotErrorStep.html';
import '!ng-cache-loader!./instagramSteps/EnablePermissionErrorStep.html';
import '!ng-cache-loader!./instagramSteps/DisabledAccessInstagramMessagesErrorSetp.html';
export class InstagramController extends ChannelBaseController {
    static $inject = ['$window', 'application', 'ApplicationService2', 'ChannelsService', 'InstagramService', 'SegmentService', 'BlipToastService', '$translate', 'LoadingService', '$q', '$timeout', 'ModalService', '$cookies', 'FacebookLoginPopupService', 'FACEBOOK_POPUP_CONNECTION_TIME', 'INSTAGRAM_AUTH_PERMISSIONS'];
    constructor($window, application, ApplicationService2, ChannelsService, InstagramService, SegmentService, BlipToastService, $translate, LoadingService, $q, $timeout, ModalService, $cookies, FacebookLoginPopupService, FACEBOOK_POPUP_CONNECTION_TIME, INSTAGRAM_AUTH_PERMISSIONS) {
        'ngInject';
        super(ChannelsNames.Instagram, ChannelsService, ApplicationService2, application);
        this.$window = $window;
        this.application = application;
        this.ApplicationService2 = ApplicationService2;
        this.ChannelsService = ChannelsService;
        this.InstagramService = InstagramService;
        this.SegmentService = SegmentService;
        this.BlipToastService = BlipToastService;
        this.$translate = $translate;
        this.LoadingService = LoadingService;
        this.$q = $q;
        this.$timeout = $timeout;
        this.ModalService = ModalService;
        this.$cookies = $cookies;
        this.FacebookLoginPopupService = FacebookLoginPopupService;
        this.FACEBOOK_POPUP_CONNECTION_TIME = FACEBOOK_POPUP_CONNECTION_TIME;
        this.INSTAGRAM_AUTH_PERMISSIONS = INSTAGRAM_AUTH_PERMISSIONS;
        this.instagramStepsEnum = InstagramStepsEnum;
        this.instagramImagesStepsEnum = InstagramImagesStepsEnum;
        this.privateReplyForLives = {};
        this.privateReply = {};
        this.storyMention = {};
        this.storyReply = {};
        this.iceBreaker = {};
        this.instagramPages = {};
        this.instagramPageHasError = false;
        this.instagramCanConnect = false;
        this.hasInstagramBusinessAccountNotFound = false;
        this.hasInstagramNotLinked = false;
        this.errorMessagePermissionsDisabled = [];
        this.errorConnectedBot = {};
        this.instagramSelectOptions = [];
        this.imagesIsLoading = new Map([
            [InstagramImagesStepsEnum.PROFESSIONAL_INSTAGRAM_IMAGE_KEY, false],
            [InstagramImagesStepsEnum.LINKED_ACCOUNTS_IMAGE_KEY, false],
            [InstagramImagesStepsEnum.MESSAGES_ACCESS_IMAGE_KEY, false],
        ]);
        this.iceBreakerQuestions = [];
        this.showEntryPointsPrivateReplies = false;
        this.privateReplyForLivesOnKeywordsChange = async (event) => {
            if (this.privateReplyForLives?.keywords?.join(',') !== event.detail.data?.join(',')) {
                this.privateReplyForLives.keywords = event.detail.data;
                await this.updateIsSaveButtonDisabledAsync(this.privateReplyForLives, false);
            }
        };
        this.privateReplyOnKeywordsChange = async (event) => {
            if (this.privateReply?.keywords?.join(',') !== event.detail.data?.join(',')) {
                this.privateReply.keywords = event.detail.data;
                this.updateIsSaveButtonDisabledAsync(this.privateReply, false);
            }
        };
        this.iceBreakerQuestionsChange = async (event) => {
            if (this.iceBreaker?.questions?.join(',') !== event.detail.data?.join(',')) {
                const inputChipQuestionsIceBreaker = event.target;
                this.iceBreaker.questions = event.detail.data;
                if (event.detail.data.length > 4) {
                    inputChipQuestionsIceBreaker.setAttribute('error-message', await this.$translate('instagram.errorMsg.icebreaker.limitQuestions'));
                    inputChipQuestionsIceBreaker.setAttribute('danger', 'True');
                    this.updateIsSaveButtonDisabledAsync(this.iceBreaker, true);
                    return;
                }
                this.updateIsSaveButtonDisabledAsync(this.iceBreaker, false);
                inputChipQuestionsIceBreaker.removeAttribute('error-message');
                inputChipQuestionsIceBreaker.removeAttribute('danger');
            }
        };
        this.onSelectInstagramPage = async (event) => {
            this.instagramPages.selected =
                this.instagramPages.eligibles.find(page => page.PageId == event.detail.value);
            if (this.instagramPages.selected.IsValid) {
                this.instagramCanConnect = true;
                this.instagramPageHasError = false;
                return;
            }
            this.instagramCanConnect = false;
            this.instagramPageHasError = true;
            this.instagramPages.selected.warnings = [];
            const connectedBotError = await this.$translate('instagram.flow.steps.connectPage.errors.connectedBot');
            const disabledAccessInstagramMessagesError = await this.$translate('instagram.flow.steps.connectPage.errors.disabledAccessInstagramMessages');
            const instagramAccountIsNotEligibleError = await this.$translate('instagram.flow.steps.connectPage.errors.notEligibleAccount');
            const knowMoreLink = await this.$translate('instagram.flow.steps.connectPage.knowMoreLink');
            for (const prop in this.instagramPages.selected.Errors) {
                if (this.instagramPages.selected.Errors.hasOwnProperty(prop)) {
                    let text;
                    switch (prop) {
                        case InstagramErrorEnum.CONNECTED_BOT:
                            text = connectedBotError;
                            text = text.replace('{bot_id}', this.instagramPages.selected.Errors[prop]);
                            this.createErrorTrackApplicationEvent(InstagramErrorEnum.CONNECTED_BOT, this.instagramPages.selected.Errors[prop]);
                            break;
                        case InstagramErrorEnum.DISABLED_ACCESS_INSTAGRAM_MESSAGES:
                            text = disabledAccessInstagramMessagesError;
                            this.createErrorTrackApplicationEvent(InstagramErrorEnum.DISABLED_ACCESS_INSTAGRAM_MESSAGES);
                            break;
                        case InstagramErrorEnum.INSTAGRAM_ACCOUNT_IS_NOT_ELIGIBLE:
                            text = instagramAccountIsNotEligibleError;
                            this.createErrorTrackApplicationEvent(InstagramErrorEnum.INSTAGRAM_ACCOUNT_IS_NOT_ELIGIBLE);
                            break;
                        default:
                            break;
                    }
                    this.instagramPages.selected.warnings.push({ text, link: knowMoreLink });
                }
            }
        };
        this.initializeConnectedPage = async (data) => {
            this.currentActivationStep = InstagramStepsEnum.CONNECT_PAGE;
            this.instagramBusinessAcountInfos = data;
            this.connectionPageError = undefined;
            const accountAvailable = await this.$translate('instagram.flow.steps.connectPage.accountAvailable');
            const accountUnavailableMoreDetails = await this.$translate('instagram.flow.steps.connectPage.accountUnavailableMoreDetails');
            this.hasInstagramBusinessAccountNotFound =
                data.InstagramBusinessAccountDetail.some(page => page.Errors.hasOwnProperty(InstagramErrorEnum.INSTAGRAM_BUSINESS_ACCOUNT_NOT_FOUND));
            this.hasInstagramNotLinked =
                data.InstagramBusinessAccountDetail.some(page => page.Errors.hasOwnProperty(InstagramErrorEnum.IS_INSTAGRAM_LINKED));
            this.instagramPages.eligibles = data.InstagramBusinessAccountDetail
                .filter(page => !page.Errors.IsInstagramLinked && !page.Errors.hasOwnProperty(InstagramErrorEnum.INSTAGRAM_BUSINESS_ACCOUNT_NOT_FOUND));
            this.instagramSelectOptions = this.instagramPages.eligibles
                .sort((page, otherPage) => page.UserName.localeCompare(otherPage.UserName))
                .map((page) => {
                return {
                    value: page.PageId,
                    titleText: '@' + page.UserName,
                    label: ` ${page.IsValid ? accountAvailable : accountUnavailableMoreDetails}`,
                };
            });
            if (this.hasInstagramBusinessAccountNotFound) {
                const errorDescription = this.GetErrorsDescription(data, InstagramErrorEnum.INSTAGRAM_BUSINESS_ACCOUNT_NOT_FOUND);
                this.createErrorTrackApplicationEvent(InstagramErrorEnum.INSTAGRAM_BUSINESS_ACCOUNT_NOT_FOUND, errorDescription);
            }
            if (this.hasInstagramNotLinked) {
                const errorDescriptionNotlinked = this.GetErrorsDescription(data, InstagramErrorEnum.IS_INSTAGRAM_LINKED);
                this.createErrorTrackApplicationEvent(InstagramErrorEnum.IS_INSTAGRAM_LINKED, errorDescriptionNotlinked);
            }
        };
        this._init();
    }
    async _init() {
        this.LoadingService.startLoading();
        try {
            this.application.channels = await this.ChannelsService.getChannel(ChannelsNames.Instagram, this.isConfigurationsApplicationsDomainUsageGetEnabled);
            this.subsidiary = await this.ChannelsService.getSubsidiary(ChannelsNames.Instagram);
            const { AppId, GraphApiVersion } = await this.loadApplicationInformation();
            this.graphApiVersion = GraphApiVersion;
            this.appId = AppId;
            await this.setInitCurrentActivationStep();
            await this.initializeConfigurationsAsync();
            this.initializeConnectedPage.bind(this);
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async trackDocumentation(doc) {
        await this.trackApplicationEvent(`channel-configuration-instagram-${doc}-documentation-clicked`);
    }
    async storyReplyOnToggle(event) {
        event.preventDefault();
        this.LoadingService.startLoading();
        this.storyReply.isActive = !this.storyReply.isActive;
        try {
            await this.InstagramService.setEntryPointsConfigurationsAsync({
                EnableStoryReply: this.storyReply.isActive ? 'True' : 'False',
            });
            await this.trackApplicationEvent(CHANNEL_CONFIGURATION_INSTAGRAM_STORY_REPLY_TOGGLE_CLICKED, {
                EnableStoryReply: this.storyReply.isActive,
            });
            this.BlipToastService.show('success', {
                title: await this.$translate('instagram.successMsg.saveEntryPoint.title'),
                msg: await this.$translate('instagram.successMsg.saveEntryPoint.msg'),
            });
        }
        catch (error) {
            console.error(error);
            this.BlipToastService.show('danger', {
                title: await this.$translate('instagram.errorMsg.saveEntryPoint.title'),
                msg: await this.$translate('instagram.errorMsg.saveEntryPoint.msg'),
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async storyMentionOnToggle(event) {
        event.preventDefault();
        this.LoadingService.startLoading();
        this.storyMention.isActive = !this.storyMention.isActive;
        try {
            await this.InstagramService.setEntryPointsConfigurationsAsync({
                EnableStoryMention: this.storyMention.isActive ? 'True' : 'False',
            });
            await this.trackApplicationEvent(CHANNEL_CONFIGURATION_INSTAGRAM_STORY_MENTION_TOGGLE_CLICKED, {
                EnableStoryMention: this.storyMention.isActive,
            });
            this.BlipToastService.show('success', {
                title: await this.$translate('instagram.successMsg.saveEntryPoint.title'),
                msg: await this.$translate('instagram.successMsg.saveEntryPoint.msg'),
            });
        }
        catch (error) {
            console.error(error);
            this.BlipToastService.show('danger', {
                title: await this.$translate('instagram.errorMsg.saveEntryPoint.title'),
                msg: await this.$translate('instagram.errorMsg.saveEntryPoint.msg'),
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async privateReplyForLivesOnToggle(event) {
        event.preventDefault();
        this.LoadingService.startLoading();
        this.privateReplyForLives.isActive = !this.privateReplyForLives.isActive;
        try {
            let keywords = this.privateReplyForLives?.keywords?.join(',') ?? '';
            if (this.privateReplyForLives.keywords.length > 0 && !(this.privateReplyForLives.isActive)) {
                keywords = '';
            }
            await this.InstagramService.setEntryPointsConfigurationsAsync({
                EnablePrivateReplyForLives: this.privateReplyForLives.isActive,
                KeywordsPrivateReplyForLives: keywords,
            });
            await this.trackApplicationEvent(CHANNEL_CONFIGURATION_INSTAGRAM_PRIVATE_REPLY_FOR_LIVES_TOGGLE_CLICKED, {
                EnablePrivateReplyForLives: this.privateReplyForLives.isActive,
            });
            this.privateReplyForLives.showKeywords = this.privateReplyForLives.isActive;
            this.BlipToastService.show('success', {
                title: await this.$translate('instagram.successMsg.saveEntryPoint.title'),
                msg: await this.$translate('instagram.successMsg.saveEntryPoint.msg'),
            });
            if (keywords.length === 0) {
                const inputChipkeywordsPrivateReplyForLives = document.getElementById('keywordsPrivateReplyForLives');
                if (inputChipkeywordsPrivateReplyForLives) {
                    inputChipkeywordsPrivateReplyForLives.clear();
                    this.privateReplyForLives.keywords = [];
                    await this.updateIsSaveButtonDisabledAsync(this.privateReplyForLives, true);
                }
            }
        }
        catch (error) {
            console.error(error);
            this.BlipToastService.show('danger', {
                title: await this.$translate('instagram.errorMsg.saveEntryPoint.title'),
                msg: await this.$translate('instagram.errorMsg.saveEntryPoint.msg'),
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async privateReplyForLivesOnSaveKeywords() {
        this.LoadingService.startLoading();
        try {
            await this.InstagramService.setEntryPointsConfigurationsAsync({
                KeywordsPrivateReplyForLives: this.privateReplyForLives.keywords.join(','),
            });
            this.BlipToastService.show('success', {
                title: await this.$translate('instagram.successMsg.saveEntryPoint.title'),
                msg: await this.$translate('instagram.successMsg.saveEntryPoint.msg'),
            });
            await this.trackApplicationEvent(CHANNEL_CONFIGURATION_INSTAGRAM_PRIVATE_REPLY_FOR_LIVES_KEYWORDS_SAVED, {
                KeywordsPrivateReplyForLives: this.privateReplyForLives.keywords.join(','),
                Error: undefined,
            });
            await this.updateIsSaveButtonDisabledAsync(this.privateReplyForLives, true);
        }
        catch (error) {
            console.error(error);
            this.BlipToastService.show('danger', {
                title: await this.$translate('instagram.errorMsg.saveEntryPoint.title'),
                msg: await this.$translate('instagram.errorMsg.saveEntryPoint.msg'),
            });
            await this.trackApplicationEvent(CHANNEL_CONFIGURATION_INSTAGRAM_PRIVATE_REPLY_FOR_LIVES_KEYWORDS_SAVED, {
                KeywordsPrivateReplyForLives: this.privateReplyForLives.keywords.join(','),
                Error: error,
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async privateReplyOnToggle(event) {
        event.preventDefault();
        this.LoadingService.startLoading();
        this.privateReply.isActive = !this.privateReply.isActive;
        try {
            let keywords = this.privateReply.keywords?.join(',') ?? '';
            if (this.privateReply?.keywords?.length > 0 && !(this.privateReply.isActive)) {
                keywords = '';
            }
            await this.InstagramService.setEntryPointsConfigurationsAsync({
                EnablePrivateReply: this.privateReply.isActive,
                KeywordsPrivateReply: keywords,
            });
            await this.trackApplicationEvent(CHANNEL_CONFIGURATION_INSTAGRAM_PRIVATE_REPLY_TOGGLE_CLICKED, {
                EnablePrivateReply: this.privateReply.isActive,
            });
            this.privateReply.showKeywords = this.privateReply.isActive;
            this.BlipToastService.show('success', {
                title: await this.$translate('instagram.successMsg.saveEntryPoint.title'),
                msg: await this.$translate('instagram.successMsg.saveEntryPoint.msg'),
            });
            if (keywords.length === 0) {
                const inputChipkeywordsPrivateReply = document.getElementById('keywordsPrivateReply');
                if (inputChipkeywordsPrivateReply) {
                    inputChipkeywordsPrivateReply.clear();
                    await this.updateIsSaveButtonDisabledAsync(this.privateReply, true);
                    this.privateReply.keywords = [];
                }
            }
        }
        catch (error) {
            console.error(error);
            this.BlipToastService.show('danger', {
                title: await this.$translate('instagram.errorMsg.saveEntryPoint.title'),
                msg: await this.$translate('instagram.errorMsg.saveEntryPoint.msg'),
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async privateReplyOnSaveKeywords() {
        this.LoadingService.startLoading();
        try {
            await this.InstagramService.setEntryPointsConfigurationsAsync({
                KeywordsPrivateReply: this.privateReply.keywords?.join(',') ?? '',
            });
            this.BlipToastService.show('success', {
                title: await this.$translate('instagram.successMsg.saveEntryPoint.title'),
                msg: await this.$translate('instagram.successMsg.saveEntryPoint.msg'),
            });
            await this.trackApplicationEvent(CHANNEL_CONFIGURATION_INSTAGRAM_PRIVATE_REPLY_KEYWORDS_SAVED, {
                KeywordsPrivateReply: this.privateReply.keywords?.join(',') ?? '',
                Error: undefined,
            });
            this.updateIsSaveButtonDisabledAsync(this.privateReply, true);
        }
        catch (error) {
            console.error(error);
            this.BlipToastService.show('danger', {
                title: await this.$translate('instagram.errorMsg.saveEntryPoint.title'),
                msg: await this.$translate('instagram.errorMsg.saveEntryPoint.msg'),
            });
            await this.trackApplicationEvent(CHANNEL_CONFIGURATION_INSTAGRAM_PRIVATE_REPLY_KEYWORDS_SAVED, {
                KeywordsPrivateReply: this.privateReply.keywords.join(','),
                Error: error,
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async iceBreakerOnToggle(event) {
        event.preventDefault();
        this.LoadingService.startLoading();
        this.iceBreaker.isActive = !this.iceBreaker.isActive;
        try {
            if (!this.iceBreaker.isActive && this.iceBreakerQuestions?.length > 0) {
                await this.InstagramService.deleteIceBreakerAsync();
                await this.trackApplicationEvent(CHANNEL_CONFIGURATION_INSTAGRAM_ICE_BREAKER, {
                    isActive: this.iceBreaker.isActive,
                    Error: undefined,
                    Questions: this.iceBreaker.questions,
                    Toggle: true,
                });
                this.BlipToastService.show('success', {
                    title: await this.$translate('instagram.successMsg.saveEntryPoint.title'),
                    msg: await this.$translate('instagram.successMsg.saveEntryPoint.msg'),
                });
                this.iceBreakerQuestions = [];
                const inputChipQuestionsIceBreaker = document.getElementById('questionsIcebreaker');
                if (inputChipQuestionsIceBreaker) {
                    inputChipQuestionsIceBreaker.clear();
                    this.updateIsSaveButtonDisabledAsync(this.iceBreaker, true);
                    this.iceBreaker.questions = [];
                }
            }
            this.iceBreaker.showQuestions = this.iceBreaker.isActive;
        }
        catch (error) {
            console.error(error);
            this.BlipToastService.show('danger', {
                title: await this.$translate('instagram.errorMsg.saveEntryPoint.title'),
                msg: await this.$translate('instagram.errorMsg.saveEntryPoint.msg'),
            });
            await this.trackApplicationEvent(CHANNEL_CONFIGURATION_INSTAGRAM_ICE_BREAKER, {
                isActive: this.iceBreaker.isActive,
                Error: undefined,
                Questions: this.iceBreaker.questions,
                Toggle: true,
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async updateIsSaveButtonDisabledAsync(entryPoint, isDisabled) {
        this.$timeout(() => {
            entryPoint.isSaveButtonDisabled = isDisabled;
        });
    }
    async iceBreakerOnSaveQuestions() {
        this.LoadingService.startLoading();
        try {
            if (this.iceBreaker.questions.length > 4) {
                return;
            }
            if (this.iceBreaker.questions.length > 0) {
                await this.InstagramService.setIceBreakerAsync(this.iceBreaker.questions);
            }
            else {
                await this.InstagramService.deleteIceBreakerAsync();
                this.iceBreaker.isActive = false;
                this.iceBreaker.showQuestions = false;
            }
            await this.trackApplicationEvent(CHANNEL_CONFIGURATION_INSTAGRAM_ICE_BREAKER, {
                IsActive: this.iceBreaker.isActive,
                Error: undefined,
                Questions: this.iceBreaker.questions,
                Toggle: false,
            });
            this.BlipToastService.show('success', {
                title: await this.$translate('instagram.successMsg.saveEntryPoint.title'),
                msg: await this.$translate('instagram.successMsg.saveEntryPoint.msg'),
            });
            this.iceBreakerQuestions = this.iceBreaker.questions;
            this.updateIsSaveButtonDisabledAsync(this.iceBreaker, true);
        }
        catch (error) {
            console.error(error);
            this.BlipToastService.show('danger', {
                title: await this.$translate('instagram.errorMsg.saveEntryPoint.title'),
                msg: await this.$translate('instagram.errorMsg.saveEntryPoint.msg'),
            });
            await this.trackApplicationEvent(CHANNEL_CONFIGURATION_INSTAGRAM_ICE_BREAKER, {
                isActive: this.iceBreaker.isActive,
                Error: error,
                Questions: this.iceBreaker.questions,
                Toggle: false,
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async onConfigurationTabClicked() {
        await this.trackApplicationEvent(CHANNEL_CONNECTION_INSTAGRAM_CONFIGURATIONS_CLICKED);
    }
    async onOverviewTabClicked() {
        await this.trackApplicationEvent(CHANNEL_CONNECTION_INSTAGRAM_OVERVIEW_CLICKED);
    }
    async setInitCurrentActivationStep() {
        await this.tryLoadInstagramAccountConnectedAsync();
        this.currentActivationStep = this.isActive ? InstagramStepsEnum.INTAGRAM_CONNECTED : InstagramStepsEnum.INSTAGRAM_OVERVIEW;
    }
    async handleStartSteps() {
        this.currentActivationStep = this.getStepContentByIndex(0);
        await this.createStepTrackApplicationEvent();
    }
    async handleNextStep() {
        const stepperComponent = document.querySelector('bds-stepper');
        const activeStep = await stepperComponent.getActiveStep();
        stepperComponent.setActiveStep(activeStep + 1);
        stepperComponent.setCompletedStep(activeStep);
        this.currentActivationStep = this.getStepContentByIndex(activeStep + 1);
        await this.createStepTrackApplicationEvent();
    }
    async handlePreviousStep() {
        const stepperComponent = document.querySelector('bds-stepper');
        const activeStep = await stepperComponent.getActiveStep();
        const previousStep = activeStep - 1;
        if (previousStep < 0) {
            this.currentActivationStep = InstagramStepsEnum.INSTAGRAM_OVERVIEW;
        }
        else if (activeStep == 4 && (this.currentActivationStep == InstagramStepsEnum.DISABLED_ACCESS_INSTAGRAM_MESSAGES_ERROR ||
            this.currentActivationStep == InstagramStepsEnum.CONNECTED_BOT_ERROR ||
            this.currentActivationStep == InstagramStepsEnum.ENABLE_PERMISSION_ERROR ||
            this.currentActivationStep == InstagramStepsEnum.INSTAGRAM_NOT_LINKED_ERROR ||
            this.currentActivationStep == InstagramStepsEnum.CONNECT_PAGE_ERROR ||
            this.currentActivationStep == InstagramStepsEnum.CONNECT_PAGE)) {
            this.currentActivationStep = InstagramStepsEnum.BLIP_CONNECTION;
        }
        else {
            stepperComponent.setActiveStep(previousStep);
            this.currentActivationStep = this.getStepContentByIndex(previousStep);
        }
        await this.createStepTrackApplicationEvent();
    }
    async handleConnectToFacebook(accessToken, state) {
        this.LoadingService.startLoading();
        try {
            this.instagramBusinessAcountInfos = undefined;
            if (state === StatusFacebookPopupConnectionEnum.SUCCESS) {
                this.instagramBusinessAcountInfos
                    = await this.InstagramService.getInstagramBusinessAccountAsync(accessToken);
                const hasPageError = await this.isPageError(this.instagramBusinessAcountInfos);
                if (!hasPageError) {
                    await this.initializeConnectedPage(this.instagramBusinessAcountInfos);
                }
            }
            this.createTrackingLoginEmbedded(CHANNEL_CONNECTION_INSTAGRAM_FACEBOOK_LOGIN_EMBEDDED, true, this.instagramBusinessAcountInfos != undefined, state != StatusFacebookPopupConnectionEnum.SUCCESS ? state : undefined);
        }
        catch (e) {
            console.error(e);
            await this.handleConnectToFacebookError(e);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async handleConnectToFacebookError(error) {
        let result = false;
        let message = await this.$translate('instagram.flow.steps.blipConnection.errors.description');
        if (error instanceof Error) {
            result = await this.validatePermissionError(error.message);
            message = message.concat('</br>', error.message);
        }
        if (!result) {
            this.BlipToastService.show('danger', {
                title: await this.$translate('instagram.flow.steps.blipConnection.errors.title'),
                msg: message,
            });
        }
        this.createTrackingLoginEmbedded(CHANNEL_CONNECTION_INSTAGRAM_FACEBOOK_LOGIN_EMBEDDED, true, false, typeof error === 'string' ? error : JSON.stringify(error));
    }
    async openDocumentation() {
        const documentationLink = await this.$translate('instagram.documentationLink');
        this.$window.open(documentationLink, '_blank');
    }
    async connectPageToInstagram() {
        this.LoadingService.startLoading();
        await this.trackApplicationEvent(CHANNEL_CONNECTION_INSTAGRAM_CLICK_CONNECT);
        const { selected } = this.instagramPages;
        const configurations = {
            IsChannelActive: 'True',
            InstagramBusinessAccountId: selected.InstagramBusinessAccountId,
            PageId: selected.PageId,
            PageAccessToken: selected.PageAccessToken,
            UserId: this.instagramBusinessAcountInfos.UserId,
        };
        try {
            await this.InstagramService.setStateConfigurationAsync(configurations);
            this.updateChannels(true);
            await this.loadInstagramAccountConnectedAsync(true);
            await this.trackApplicationEvent(CHANNEL_CONNECTION_INSTAGRAM_CONNECTION_SUCCESSFUL);
        }
        catch (error) {
            await this.showConnectPageError(error);
            console.error(error);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    updateChannels(isActive) {
        this.isActive = isActive;
        this.channel.configurations.IsChannelActive = isActive ? 'True' : 'False';
        this.ChannelsService.updateChannelConfigurations(this.channel);
    }
    openLoginPopup() {
        clearInterval(this.timerId);
        const [state, tab] = this.FacebookLoginPopupService.openFacebookLoginPopup(this.appId, this.graphApiVersion, this.INSTAGRAM_AUTH_PERMISSIONS);
        const timeToStopPoolingFacebookCookie = new Date(new Date().getTime() + this.FACEBOOK_POPUP_CONNECTION_TIME);
        this.timerId = setInterval(() => {
            if (this.$cookies.getObject(state)) {
                const { accessToken } = this.$cookies.getObject(state);
                clearInterval(this.timerId);
                this.handleConnectToFacebook(accessToken, StatusFacebookPopupConnectionEnum.SUCCESS);
                return;
            }
            if (new Date() > timeToStopPoolingFacebookCookie) {
                clearInterval(this.timerId);
                this.handleConnectToFacebook(undefined, StatusFacebookPopupConnectionEnum.TIME_OUT);
                return;
            }
            if (this.currentActivationStep != this.instagramStepsEnum.BLIP_CONNECTION || tab.closed) {
                clearInterval(this.timerId);
            }
        }, 2000);
    }
    async showConnectPageError(error) {
        this.currentActivationStep = InstagramStepsEnum.CONNECT_PAGE_ERROR;
        await this.trackApplicationEvent(CHANNEL_CONNECTION_INSTAGRAM_CONNECTION_ERROR, { Error: error });
        this.connectionPageError = error?.description;
    }
    async initializeConfigurationsAsync() {
        if (!this.isActive) {
            return;
        }
        const entryPointsConfigurations = await this.InstagramService.getEntryPointsConfigurationsAsync();
        const iceBreakerQuestions = await this.GetIcebreakerQuestionAsync();
        this.configurations = entryPointsConfigurations;
        this.iceBreakerQuestions = iceBreakerQuestions;
        if (!entryPointsConfigurations) {
            throw new Error('Not possible to retrieve EntryPoints configurations.');
        }
        this.$timeout(() => {
            this.addPrivateReplyForLivesConfigurations(entryPointsConfigurations);
            this.addPrivateReplyConfigurations(entryPointsConfigurations);
            this.addStoryMentionConfigurations(entryPointsConfigurations);
            this.addStoryReplyconfigurations(entryPointsConfigurations);
            this.addIceBreakerConfigurations(iceBreakerQuestions);
        });
    }
    async GetIcebreakerQuestionAsync() {
        try {
            const iceBreakerQuestions = await this.InstagramService.getIceBreakerAsync();
            const questions = iceBreakerQuestions.IceBreakers?.find((i) => i.Locale === 'default')?.CallToActions?.map((action) => action.Question);
            return questions;
        }
        catch (error) {
            return [];
        }
    }
    addStoryReplyconfigurations(configurations) {
        this.storyReply = {
            isActive: configurations.EnableStoryReply == 'True',
        };
    }
    addStoryMentionConfigurations(configurations) {
        this.storyMention = {
            isActive: configurations.EnableStoryMention == 'True',
        };
    }
    addPrivateReplyForLivesConfigurations(configurations) {
        this.privateReplyForLives = {
            isActive: configurations.EnablePrivateReplyForLives == 'True',
            keywords: configurations.KeywordsPrivateReplyForLives ? configurations.KeywordsPrivateReplyForLives.split(',') : [],
            showKeywords: configurations.EnablePrivateReplyForLives == 'True',
            isSaveButtonDisabled: true,
        };
    }
    addPrivateReplyConfigurations(configurations) {
        this.privateReply = {
            isActive: configurations.EnablePrivateReply == 'True',
            keywords: configurations.KeywordsPrivateReply ? configurations.KeywordsPrivateReply.split(',') : [],
            showKeywords: configurations.EnablePrivateReply == 'True',
            isSaveButtonDisabled: true,
        };
    }
    addIceBreakerConfigurations(questions) {
        this.iceBreaker = {
            isActive: (questions?.length > 0),
            questions: questions ? questions : [],
            showQuestions: (questions?.length > 0),
            isSaveButtonDisabled: true,
        };
    }
    async createStepTrackApplicationEvent() {
        await this.trackApplicationEvent(CHANNEL_CONNECTION_INSTAGRAM_CURRENT_ACTIVATION_STEP, {
            CurrentActivationStep: InstagramStepsEnum[this.currentActivationStep],
        });
    }
    async createErrorTrackApplicationEvent(error, description = '') {
        await this.trackApplicationEvent(CHANNEL_CONNECTION_INSTAGRAM_ERROR_PAGES, {
            Error: error,
            Description: description,
        });
    }
    async createTrackingLoginEmbedded(stepFlow, isConnect, isSuccess, error) {
        await this.trackApplicationEvent(stepFlow, { botId: this.application.shortName, channel: 'Instagram', botName: this.application.name, connect: isConnect, success: isSuccess, error: error });
    }
    async trackApplicationEvent(event, payload) {
        const application = this.application;
        await this.SegmentService.createApplicationTrack({
            trackEvent: event,
            application,
            payload: { ...payload },
        });
    }
    getStepContentByIndex(index) {
        const content = {
            0: InstagramStepsEnum.COMMERCIAL_FACEBOOK,
            1: InstagramStepsEnum.PROFESSIONAL_INSTAGRAM,
            2: InstagramStepsEnum.LINKED_ACCOUNTS,
            3: InstagramStepsEnum.MESSAGES_ACCESS,
            4: InstagramStepsEnum.BLIP_CONNECTION,
            5: InstagramStepsEnum.CONNECT_PAGE,
        };
        return content[index];
    }
    async openModalSuccessConnectDprAsync() {
        await this.ModalService.showModal({
            template: InstagramSuccesConnectModalDpr,
            controller: InstagramSuccesConnectModalControllerDpr,
            controllerAs: '$ctrl',
            inputs: {
                openConfiguration: this.openTabConfiguration.bind(this),
            },
        });
    }
    async openModalSuccessConnectAsync() {
        await this.ModalService.showModal({
            template: InstagramSuccesConnectModal,
            controller: InstagramSuccesConnectModalController,
            controllerAs: '$ctrl',
            inputs: {
                application: this.application,
            },
        });
    }
    async openTabConfiguration() {
        const tabTitle = document.getElementById('configuration-tab');
        setTimeout(() => {
            tabTitle.click();
        }, 20);
    }
    async openModalDisconnectAsync() {
        await this.trackApplicationEvent(CHANNEL_DISCONNECTION_INSTAGRAM_START, {
            isActive: this.isActive,
            success: true,
            error: undefined,
        });
        await this.ModalService.showModal({
            template: InstagramDisconnectModal,
            controller: InstagramDisconnectModalController,
            controllerAs: '$ctrl',
            inputs: {
                disconnectPage: this.disconnectPageAsync.bind(this),
            },
        });
    }
    async disconnectPageAsync(disconnectionMotive) {
        this.LoadingService.startLoading();
        const configurations = {
            IsChannelActive: 'False',
            KeepConfigurations: ['IsChannelActive'],
        };
        try {
            await this.InstagramService.setStateConfigurationAsync(configurations);
            this.isActive = false;
            this.InstagramAccountConnected = undefined;
            this.currentActivationStep = InstagramStepsEnum.INSTAGRAM_OVERVIEW;
            this.updateChannels(false);
            this.BlipToastService.show('success', {
                msg: await this.$translate('instagram.successMsg.disconnection.title'),
            });
            await this.trackApplicationEvent(CHANNEL_DISCONNECTION_INSTAGRAM, {
                success: true,
                disconnectionMotive,
                error: undefined,
            });
        }
        catch (err) {
            if (err.code == 67 && err.description == 'This gateway is already deactivated') {
                this.BlipToastService.show('success', {
                    msg: await this.$translate('instagram.successMsg.disconnection.title'),
                });
            }
            else {
                this.BlipToastService.show('danger', {
                    title: await this.$translate('instagram.errorMsg.disconnection.title'),
                    msg: await this.$translate('instagram.errorMsg.disconnection.msg'),
                });
            }
            await this.trackApplicationEvent(CHANNEL_DISCONNECTION_INSTAGRAM, {
                success: false,
                disconnectionMotive,
                error: err.description,
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async tryLoadInstagramAccountConnectedAsync() {
        try {
            const validatePageToken = await this.ChannelsService.checkTokenIsValid(ChannelsNames.Instagram);
            if (validatePageToken?.IsValidAccessToken) {
                await this.loadInstagramAccountConnectedAsync();
                return;
            }
            this.isActive = false;
        }
        catch (error) {
            console.error(error);
            await this.trackApplicationEvent(CHANNEL_CONNECTION_INSTAGRAM_LOAD_ACCOUNT_ERROR, { Error: error });
        }
    }
    async loadInstagramAccountConnectedAsync(openModalSuccessConnect = false) {
        try {
            const account = await this.InstagramService.getInstagramAccountProfileConnectedAsync();
            if (account) {
                this.isActive = true;
                this.InstagramAccountConnected = account;
            }
            if (openModalSuccessConnect) {
                const enabled = await ChannelsFeatures.isEmailRegistrationInstagramEnabled();
                if (enabled) {
                    await this.trackApplicationEvent(CHANNEL_CONNECTION_INSTAGRAM_CURRENT_ACTIVATION_STEP, {
                        CurrentActivationStep: InstagramStepsEnum[InstagramStepsEnum.CONFIGURATION_EMAIL],
                    });
                    await this.openModalSuccessConnectAsync();
                }
                else {
                    await this.openModalSuccessConnectDprAsync();
                }
            }
            this.currentActivationStep = InstagramStepsEnum.INTAGRAM_CONNECTED;
        }
        catch (error) {
            console.error(error);
            await this.trackApplicationEvent(CHANNEL_CONNECTION_INSTAGRAM_LOAD_ACCOUNT_ERROR, { Error: error });
        }
    }
    async validatePermissionError(message) {
        this.errorMessagePermissionsDisabled = [];
        if (message.match('Permissions not found')) {
            this.currentActivationStep = InstagramStepsEnum.ENABLE_PERMISSION_ERROR;
            if (message.match(InstagramPermissionErroEnum.INSTAGRAM_BASIC)) {
                const msg = await this.$translate('instagram.flow.steps.onePageError.enableFacebookPermissions.instagramBasic');
                this.errorMessagePermissionsDisabled.push(msg);
            }
            if (message.match(InstagramPermissionErroEnum.INSTAGRAM_MANAGE_MESSAGES)) {
                const msg = await this.$translate('instagram.flow.steps.onePageError.enableFacebookPermissions.instagramManageMessages');
                this.errorMessagePermissionsDisabled.push(msg);
            }
            if (message.match(InstagramPermissionErroEnum.PAGES_MANAGE_METADATA)) {
                const msg = await this.$translate('instagram.flow.steps.onePageError.enableFacebookPermissions.pagesManageMetadata');
                this.errorMessagePermissionsDisabled.push(msg);
            }
            if (message.match(InstagramPermissionErroEnum.PAGES_MESSAGING)) {
                const msg = await this.$translate('instagram.flow.steps.onePageError.enableFacebookPermissions.pageMesssages');
                this.errorMessagePermissionsDisabled.push(msg);
            }
            if (message.match(InstagramPermissionErroEnum.PAGES_SHOW_LIST)) {
                const msg = await this.$translate('instagram.flow.steps.onePageError.enableFacebookPermissions.pageShowList');
                this.errorMessagePermissionsDisabled.push(msg);
            }
            if (message.match(InstagramPermissionErroEnum.PAGES_READ_ENGAGEMENT)) {
                const msg = await this.$translate('instagram.flow.steps.onePageError.enableFacebookPermissions.pagesReadEngagementPageShowList');
                this.errorMessagePermissionsDisabled.push(msg);
            }
            await this.createErrorTrackApplicationEvent(InstagramErrorEnum.ENABLE_PERMISSION, message);
            return true;
        }
        return false;
    }
    async isPageError(instagramBusinessAccount) {
        if (!(instagramBusinessAccount?.InstagramBusinessAccountDetail?.length > 0)) {
            this.BlipToastService.show('danger', {
                title: await this.$translate('instagram.flow.steps.blipConnection.errors.title'),
                msg: await this.$translate('instagram.flow.steps.blipConnection.errors.description'),
            });
            return true;
        }
        const hasConnectedBot = instagramBusinessAccount.InstagramBusinessAccountDetail.some(page => page.Errors.hasOwnProperty(InstagramErrorEnum.CONNECTED_BOT));
        const hasDisabledAccessInstagramMessages = instagramBusinessAccount.InstagramBusinessAccountDetail.some(page => page.Errors.hasOwnProperty(InstagramErrorEnum.DISABLED_ACCESS_INSTAGRAM_MESSAGES));
        const hasInstagramNotLinked = instagramBusinessAccount.InstagramBusinessAccountDetail.every(page => page.Errors.hasOwnProperty(InstagramErrorEnum.IS_INSTAGRAM_LINKED));
        if (instagramBusinessAccount.InstagramBusinessAccountDetail.length === 1 || hasInstagramNotLinked) {
            if (hasInstagramNotLinked) {
                this.currentActivationStep = InstagramStepsEnum.INSTAGRAM_NOT_LINKED_ERROR;
                await this.createErrorTrackApplicationEvent(InstagramErrorEnum.IS_INSTAGRAM_LINKED);
                return true;
            }
            if (hasDisabledAccessInstagramMessages) {
                this.currentActivationStep = InstagramStepsEnum.DISABLED_ACCESS_INSTAGRAM_MESSAGES_ERROR;
                await this.createErrorTrackApplicationEvent(InstagramErrorEnum.DISABLED_ACCESS_INSTAGRAM_MESSAGES);
                return true;
            }
            if (hasConnectedBot) {
                this.currentActivationStep = InstagramStepsEnum.CONNECTED_BOT_ERROR;
                const description = instagramBusinessAccount.InstagramBusinessAccountDetail[0].Errors[InstagramErrorEnum.CONNECTED_BOT];
                await this.createErrorTrackApplicationEvent(InstagramErrorEnum.CONNECTED_BOT, description);
                await this.setErrorConnectedBot(instagramBusinessAccount.InstagramBusinessAccountDetail[0]);
                return true;
            }
        }
        return false;
    }
    async setErrorConnectedBot(instagramBusinessAccount) {
        this.errorConnectedBot.title = await this.$translate('instagram.flow.steps.onePageError.connectedBot.title');
        this.errorConnectedBot.description = await this.$translate('instagram.flow.steps.onePageError.connectedBot.description');
        this.errorConnectedBot.title = this.errorConnectedBot.title.replace('{bot_id}', instagramBusinessAccount.Errors[InstagramErrorEnum.CONNECTED_BOT]);
        this.errorConnectedBot.description = this.errorConnectedBot.description.replace('{bot_id}', instagramBusinessAccount.Errors[InstagramErrorEnum.CONNECTED_BOT]);
        this.errorConnectedBot.description = this.errorConnectedBot.description.replace('{account_name}', instagramBusinessAccount.UserName);
    }
    onLoadImage(key) {
        this.imagesIsLoading[key] = true;
    }
    GetErrorsDescription(data, errorEnum) {
        try {
            const errorPages = data.InstagramBusinessAccountDetail
                .filter(page => page.Errors.hasOwnProperty(errorEnum));
            const errors = errorPages?.map((page) => {
                return 'PageId-' + page.PageId + ' = ' + page.Errors[errorEnum];
            });
            const errorDescription = errors?.join(' / ');
            return errorDescription;
        }
        catch (error) {
            console.log(error);
        }
    }
    async loadApplicationInformation() {
        const result = await this.ChannelsService.getFacebookAppInformation(ChannelsNames.Instagram, this.subsidiary);
        return result;
    }
}
InstagramController.$inject = ['$window', 'application', 'ApplicationService2', 'ChannelsService', 'InstagramService', 'SegmentService', 'BlipToastService', '$translate', 'LoadingService', '$q', '$timeout', 'ModalService', '$cookies', 'FacebookLoginPopupService', 'FACEBOOK_POPUP_CONNECTION_TIME', 'INSTAGRAM_AUTH_PERMISSIONS'];
